import React from 'react';
import { Container, Typography, Box, Grid, TextField, Button } from '@mui/material';
import { theme } from '../styles/theme';

const ContactUs = () => {
  return (
    <Box sx={{ minHeight: '100vh', bgcolor: theme.palette.background.default }}>
      <Container maxWidth="lg" sx={{ py: 8 }}>
        <Typography variant="h2" component="h1" align="center" sx={{ color: theme.palette.primary.main, mb: 4 }}>
          Contact Us
        </Typography>
        <Grid container spacing={4}>
          <Grid item xs={12} md={6}>
            <Typography variant="h5" sx={{ color: theme.palette.secondary.main, mb: 2 }}>
              Get in Touch
            </Typography>
            {/* <Typography variant="body1" sx={{ mb: 3 }}>
              Address: 123 Water Street, Tank City, 123456
            </Typography> */}
            <Typography variant="body1" sx={{ mb: 3 }}>
              Email: yogipluswatertank@gmail.com
            </Typography>
          </Grid>
          <Grid item xs={12} md={6}>
            <Box component="form" sx={{ mt: 1 }}>
              <TextField
                margin="normal"
                required
                fullWidth
                id="name"
                label="Name"
                name="name"
                autoComplete="name"
                autoFocus
              />
              <TextField
                margin="normal"
                required
                fullWidth
                id="email"
                label="Email Address"
                name="email"
                autoComplete="email"
              />
              <TextField
                margin="normal"
                required
                fullWidth
                id="subject"
                label="Subject"
                name="subject"
              />
              <TextField
                margin="normal"
                required
                fullWidth
                multiline
                rows={4}
                id="message"
                label="Message"
                name="message"
              />
              <Button
                type="submit"
                fullWidth
                variant="contained"
                sx={{ mt: 3, mb: 2, bgcolor: theme.palette.primary.main }}
              >
                Send Message
              </Button>
            </Box>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default ContactUs;